import React from 'react';
import { getArticle } from '~/helpers/article';

const PageRef = ({ page }) => {
  const article = getArticle(page);

  if (article) {
    return (
      <div className="link__container">
        <a href={article.path} className="link__element">
          <span className="icon icon-arrow-next" />
          {article.title}
        </a>
      </div>
    );
  }

  return null;
};

export default PageRef;
